import { CloseIcon } from '../Icons';
import { IconButton, createStyles, makeStyles } from '@material-ui/core';
import { Typography } from '../Typography';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import React from 'react';
const useStyles = makeStyles((theme) => createStyles({
    root: {
        margin: 0,
        padding: theme.spacing(2, 3),
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    container: {
        overflowY: 'auto',
    },
}));
export const DialogTitle = (props) => {
    const { children, onClose } = props;
    const classes = useStyles();
    return (React.createElement(MuiDialogTitle, { disableTypography: true, className: classes.root },
        React.createElement(Typography, { variant: "h6", align: "center" }, children),
        onClose ? (React.createElement(IconButton, { "aria-label": "close", onClick: onClose },
            React.createElement(CloseIcon, null))) : null));
};
//# sourceMappingURL=ModalCommon.js.map